// @flow

import * as React from 'react';

import { superpathjoin } from 'superpathjoin';

import { selectHelpdeskUrl } from '@gandi/authentication';
import { selectFromConfig } from '@gandi/redux-config';
import { useTranslator, localeSelector } from '@gandi/translate';
import { AddonButton, Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks/useAppSelector';

import type { LayoutUrls } from 'src/modules/app/selectors';

import { selectShopCurrent } from '../../../modules/organization/selectors';

import styles from './CookieConsentDialog.scss';

// XXX: refactor, same as src/modules/app/selectors
const selectLayoutUrls = selectFromConfig<LayoutUrls>('app.layout.urls', {});

type Props = {
  onClickAcceptCookies: (SyntheticMouseEvent<>) => mixed,
  onClickCloseBox: (SyntheticMouseEvent<>) => mixed,
};

export default function WarningBox({
  onClickAcceptCookies,
  onClickCloseBox,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const locale = useAppSelector(localeSelector);
  const sharingDetails =
    useAppSelector(state => selectShopCurrent(state, false)) || {};
  const publicUrls = useAppSelector(selectLayoutUrls);
  const helpUrl = useAppSelector(selectHelpdeskUrl);

  const ppUrl = sharingDetails.bu_id
    ? superpathjoin(
        publicUrls.v5_prefix,
        locale,
        'contracts',
        `pp?bu_id=${sharingDetails.bu_id}`,
      )
    : superpathjoin(publicUrls.v5_prefix, locale, 'contracts', 'pp');

  return (
    <div className={styles.opened}>
      <div className={styles.containerTop}>
        <p className={styles.openedTitle}>
          {__('The chat tool requires accepting cookies.')}
        </p>
        <AddonButton
          hitzone="overlay"
          intent="remove"
          onClick={onClickCloseBox}
        >
          {__('Close')}
        </AddonButton>
      </div>
      <div className={styles.openedContainer}>
        <p
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={__(
            'The chat tool requires cookies to function properly. ' +
              'You can see the details of the cookies used in ' +
              '<a href="%(pp_url)s">our privacy and cookie use policy</a>.',
            {
              pp_url: ppUrl,
              withHTML: true,
            },
          )}
          className={styles.openedInfo}
        />
        <p className={styles.openedInfo}>
          {__(
            `Accept them to continue or use our support form ` +
              'if you refuse them.',
          )}
        </p>
      </div>

      <div className={styles.bottom}>
        <Button type="button" small onClick={onClickAcceptCookies}>
          {__('Accept')}
        </Button>
        <Button kind="link" href={superpathjoin(helpUrl, 'requests', 'new')}>
          {__('Use form instead')}
        </Button>
      </div>
    </div>
  );
}
